<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <el-form
            ref="form"
            :model="form"
            class="demo-ruleForm"
            label-width="120px"
            label-position="left"
          >
            <p class="order-title-boxs"><span class="blueBlock"></span><i>顾客信息</i></p>
            <div class="totals-box pl24 mt20">
            <div class="flex-row mb30">
              <div class="itemName">顾客姓名</div>
              <div class="itemNum">{{ form.customerName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">手机号</div>
              <div class="itemNum">{{ form.mobile }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">备注</div>
              <div class="itemNum">{{ form.remark }}</div>
            </div>
          </div>

            <!-- <el-form-item class="el-form-item-update" label="顾客姓名：">{{ form.customerName }}</el-form-item>
            <el-form-item class="el-form-item-update" label="手机号：">{{ form.mobile }}</el-form-item>
            <el-form-item class="el-form-item-update jishi" label="订单状态：">{{ form.orderStatusCn }}</el-form-item>
            <el-form-item class="el-form-item-update" label="备注：">{{ form.remark }}</el-form-item>
            <el-form-item class="el-form-item-update" label="赠送时间：">{{ formatDate(form.oxCtime) }}</el-form-item> -->
            <div class="audit-title align-items" v-if="form && form.giftOrderItemList.length > 0 ">
              <p class="order-title-boxs"><span class="blueBlock"></span><i>赠品明细</i></p>
              <p class="jishi giftStatus">{{form.orderStatusCn}}</p>
            </div>
            <!-- <div class="audit-boxs" v-if="form && form.giftOrderItemList.length > 0 ">
              <div v-for="(item,index) in form.giftOrderItemList" :key="index" class="group-list">
                  <div class="list-left">
                    <span class="text">{{ item.itemName?item.itemName:'' }}</span>
                    <span>{{ item.auditOpIdCn?item.auditOpIdCn:'' }}</span>
                    <p class="time">服务技师</p>
                  </div>
                  <div class="list-right">
                    <p class="money">x{{ item.itemNum }}</p>
                    <p class="" style="margin-top: 8px;">{{ item.staffNames }}</p>
                  </div>
                </div>
            </div> -->
            <div class="audit-boxs plr16" v-if="form && form.giftOrderItemList.length > 0 ">
              <el-table :data="form.giftOrderItemList" border>
                <el-table-column prop="itemName" label="商品名称"></el-table-column>
                <el-table-column prop="itemNum" label="数量"></el-table-column>
                <el-table-column prop="staffNames" label="技师"></el-table-column>
              </el-table>
            </div>
            <!-- <el-form-item label="审核明细：">
              <el-table :data="form.invoiceLogVOList" border>
                <el-table-column prop="nodeName" label="审核流程"></el-table-column>
                <el-table-column prop="auditOpIdCn" label="审核人"></el-table-column>
                <el-table-column prop="auditOpIdCn" label="审核时间" width="150">
                  <template
                    slot-scope="scope"
                  >{{ scope.row.auditTime?formatDate(scope.row.auditTime):'' }}</template>
                </el-table-column>
                <el-table-column prop="auditStatusCn" label="审核状态"></el-table-column>
                <el-table-column prop="auditAmount" label="审核金额"></el-table-column>
                <el-table-column prop="auditRemark" label="审核备注"></el-table-column>
              </el-table>
            </el-form-item>-->
          </el-form>
        </div>
        <div class="drawer-footer">
          <div class="btns">
            <el-button @click="back">取消</el-button>
            <el-button type="primary" v-perm="{key:'shopGift', value:'shopGift:invalid'}" v-if="form.cancelFlag" @click="cancel">赠送作废</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      radio: 0,
      addEditTitle: "赠品详情",
      addEditShow: false,
      options: [],
      form: {
        giftOrderItemList: []
      }
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      //   this.$router.push("/collectMoney");
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.addEditShow = true;
        this.$api.get(this.$url.giftOrderInfo.get, {
            id: org.id
          })
          .then(res => {
            if (res) {
              this.form = res;
            }
          });
      });
    },
    cancel (row) {
        // 取消
        this.$confirm("确定作废当前赠送订单吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        }).then(() => {
          this.$api.get(this.$url.giftOrderInfo.cancel, {
              id: this.form.id
            }).then(res => {
              if (res) {
                this.$message.error("作废成功");
                this.addEditShow = false;
                this.$emit("change", true);
              }
            });
        })
        .catch(() => {});
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", false);
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.pay-mains {
  padding: 0;
  .giftStatus {
      padding-right: 26px;
  }
  /deep/ .el-form-item__content {
    .el-form-item__error {
      right: 0;
    }
  }
  /deep/ .el-form {
    padding-bottom: 20px;
    /deep/ .el-form-item {
      border-bottom: 1px solid @borderColor;
      padding: 10px 26px;
      margin-bottom: 0;
      // &:last-child {
      //   border-bottom: 0;
      // }
    }
    .el-form-item-update {
      padding: 0 26px;
      align-items: center;
      display: flex;
      margin: 0;
      justify-content: space-between;
      border-bottom: 1px solid @borderColor;
      /deep/ .el-form-item__label {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        // text-align: left;
      }
      /deep/ .el-form-item__content {
        flex: 2;
        text-align: right;
        // display: flex;
        .el-form-item__error {
          right: 0;
        }
      }
      /deep/ .el-input__inner {
        height: 46px;
        
        padding: 0;
        text-align: right;
      }
      /deep/.el-select .el-input__inner {
        padding: 0 30px;
      }
      /deep/ .el-radio__inner {
        width: 22px;
        height: 22px;
      }
      /deep/ .el-radio__label {
        font-size: 16px;
      }
    }
  }
}
.group-list {
  display: flex;
  justify-content: space-between;
  padding: 10px 26px;
  color: #606266;
  .list-left {
    .text {
      margin-right: 40px;
    }
    .time {
      margin-top: 10px;
    }
  }
  .list-right {
    text-align: right;
    .money {
      color: @money;
    }
  }
}
/deep/ .el-form-item__content {
    text-align: right;
    flex: 1;
    line-height: 15px !important;
}
.form-shop {
    /deep/ .el-form-item__content {
        padding: 10px 0;
    }
}
</style>